// saved-tours-settings
import { ArrowLeft, LayoutTemplate, Palette, Plug } from "lucide-react"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import BrandingTab from "./components/Brandingtab"
import ExtensionTab from "./components/ExtensionTab"
import TemplatesTab from "./components/TemplatesTab"

const TABS = [
  {
    key: "templates",
    labelKey: "saved_tours.share.templates",
    icon: LayoutTemplate,
    Component: TemplatesTab,
  },
  {
    key: "branding",
    labelKey: "saved_tours.branding.title",
    icon: Palette,
    Component: BrandingTab,
  },
  {
    key: "extension",
    labelKey: "saved_tours.extension.title",
    icon: Plug,
    Component: ExtensionTab,
  },
]

const App = ({ sessionsUrl = `${window.location.origin}/book/saved_tours/index`, isAdmin }) => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState(TABS[0].key)

  return (
    <div className="min-h-screen w-full bg-[#F4F6F9] py-4 sm:py-6 md:py-10 px-3 sm:px-4 md:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center gap-3 mb-4 sm:mb-6">
          {sessionsUrl && (
            <a
              href={sessionsUrl}
              className="p-2 rounded-lg text-[#9AA5B4] hover:text-[#26303D] hover:bg-[#EEF1F5] transition-colors shrink-0"
            >
              <ArrowLeft size={18} />
            </a>
          )}
          <h1 className="text-base sm:text-lg font-semibold text-[#1F2733]">
            {t("saved_tours.module_management.title", "Управление модулем")}
          </h1>
        </div>

        <div className="bg-white rounded-2xl border border-[#E7EAEF] overflow-hidden flex flex-col md:flex-row">
          <div className="flex md:flex-col gap-1 border-b md:border-b-0 md:border-r border-[#E7EAEF] p-2 sm:p-3 md:w-56 shrink-0 overflow-x-auto">
            {TABS.map(({ key, labelKey, icon: Icon }) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`flex items-center gap-2 text-sm text-left px-3 py-2 rounded-lg transition-colors whitespace-nowrap shrink-0
                            ${
                              activeTab === key
                                ? "bg-[#1F2937] text-white"
                                : "text-[#5A6779] hover:bg-[#F4F6F9]"
                            }`}
              >
                <Icon size={15} className="shrink-0" />
                {t(labelKey, key === "branding" ? "Оформление подборки" : undefined)}
              </button>
            ))}
          </div>

          <div className="flex-1 min-w-0 p-4 sm:p-5 md:p-6">
            {TABS.map(({ key, Component }) => (
              <div key={key} className={activeTab === key ? "block" : "hidden"}>
                <Component active={activeTab === key} isAdmin={isAdmin} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default App
